var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserPermissions } from "healthex-common/user.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { autorun, computed, observable } from "mobx";
import { validators } from "../../Logic/Validators";
export function isValidInviteEmail(email) {
    const trimmed = email.trim();
    return trimmed.length > 0 && validators.validEmail(trimmed);
}
export const PASSWORD_PLACEHOLDER = "****************";
export class GlobalAdminUserFormModelBase {
    get showFullDetail() {
        return this.opts.mode !== "new" && this.opts.mode !== "initialUser";
    }
    constructor(opts) {
        this.opts = opts;
        this.editing = opts.mode === "new" || opts.mode === "initialUser";
        window.setTimeout(() => {
            autorun(() => {
                if (opts.mode === "detail") {
                    void this.loadUser(opts.organizationId, opts.userId, false);
                }
            });
        }, 0);
    }
    cancel() {
        if (this.opts.mode === "new") {
            this.opts.onCancel();
        }
        else {
            this.editing = false;
        }
    }
    async save() {
        if (this.opts.mode === "new") {
            const userId = await this.performCreate();
            await this.loadUser(this.opts.organizationId, userId, true);
            this.opts.onCreate(userId);
        }
    }
    async forcePasswordChange() {
        if (this.opts.mode === "detail") {
            await this.forcePasswordReset();
        }
    }
    describePermission(permission) {
        switch (permission) {
            case UserPermissions.ORG_ADMIN:
                return "IT Admin";
            case UserPermissions.RESEARCH_ADMIN:
                return "Research Admin";
            case UserPermissions.GLOBAL_PROVISIONING:
                return "System-wide Provisioning";
            case UserPermissions.NONE:
            case UserPermissions.RESEARCHER:
            case UserPermissions.PROVIDER:
                return null;
        }
        return willNeverHappen(permission);
    }
}
__decorate([
    computed
], GlobalAdminUserFormModelBase.prototype, "showFullDetail", null);
__decorate([
    observable
], GlobalAdminUserFormModelBase.prototype, "editing", void 0);
